import { Component, OnInit, AfterViewInit, AfterViewChecked, AfterContentInit, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from 'app/services/http.service';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { environment } from '../../environments/environment';

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    collapse?: string;
    icontype: string;
    // icon: string;
    children?: ChildrenItems[];
    role?: any[];
    visible: boolean
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
    role?: any[];
    visible?: boolean;
}

//Menu Items
export const ROUTES: any[] = [
    {
        path: '/home',
        title: 'Home',
        type: 'link',
        icontype: 'home',
        role: ['SUPER'],
        visible: true
    },
    {
        path: '/empresas',
        title: 'Empresas',
        type: 'link',
        icontype: 'apartment',
        role: ['SUPER'],
        visible: false
    },
    {
        path: '/instalaciones',
        title: 'Instalaciones',
        type: 'link',
        icontype: 'store',
        role: ['SUPER'],
        visible: false
    },
    {
        path: '/supervisores',
        title: 'Supervisores',
        type: 'link',
        icontype: 'manage_accounts',
        role: ['SUPER'],
        visible: false
    },
    {
        path: '/usuarios',
        title: 'Usuarios',
        type: 'link',
        icontype: 'group',
        role: ['SUPER'],
        visible: false
    },
    {
        path: '/soporte',
        title: 'System Logs',
        type: 'link',
        icontype: 'engineering',
        role: ['SUPER'],
        visible: false
    },
    {
        path: '/versionesapps',
        title: 'Versiones de Apps',
        type: 'link',
        icontype: 'system_update',
        role: ['SUPER'],
        visible: true
    },
    {
        // Una sola entrada. Empezaron siendo dos —'Conector MCP' para emitir y
        // revocar keys, 'Adopcion MCP' para el total— y eran los mismos datos
        // vistos de dos formas: habia que saber de antemano en cual de las dos
        // estaba lo que uno buscaba.
        path: '/mcpadopcion',
        title: 'Adopción MCP',
        type: 'link',
        icontype: 'hub',
        role: ['SUPER'],
        visible: true
    },
    {
        path: '/promociones',
        title: 'Promociones',
        type: 'link',
        icontype: 'local_offer',
        role: ['SUPER'],
        visible: true
    },
    {
        path: '/botonpanico',
        title: 'Botón de Pánico',
        type: 'link',
        icontype: 'campaign',
        role: ['SUPER'],
        // environment.botonPanicoEnMenu es el interruptor mientras el modulo se
        // termina de probar: en produccion va apagado y la pantalla solo se
        // alcanza escribiendo la URL. Se enciende cuando el flujo este validado.
        visible: environment.botonPanicoEnMenu
    },
    {
        path: '/prefactura',
        title: 'PreFactura',
        type: 'link',
        icontype: 'shopping_cart',
        role: ['SUPER'],
        visible: false
    },
    // {
    //     path: '/facturacion',
    //     title: 'Facturación',
    //     type: 'link',
    //     icontype: 'paid',
    //     role: ['SUPER'],
    //     visible: false
    // },

    {
        path: '',
        title: 'Marketing',
        type: 'sub',
        collapse: 'maestros',
        icontype: 'workspace_premium',
        children: [

            { path: 'avancesmarketing', title: 'Avances Marketing', ab: 'AM', role: ['SUPER'] },
            // { path: 'supervisores', title: 'Supervisores', ab: 'SU', role: ['SUPER'] },
            // { path: 'usuarios', title: 'Usuarios', ab: 'US', role: ['SUPER'] },
        ],
        role: ['SUPER'],
        visible: true
    },
    {
        path: '/cambiapassword',
        title: 'Cambiar contraseña',
        type: 'link',
        icontype: 'key',
        role: ['SUPER'],
        visible: false
    },
    // {
    //     path: '',
    //     title: 'Configuración',
    //     type: 'sub',
    //     collapse: 'configuracion',
    //     icontype: 'settings',
    //     children: [
    //         // { path: 'usuarios', title: 'Usuarios', ab: 'CL', role: ['SUPER'] },
    //         { path: 'cambiapassword', title: 'Cambiar contraseña', ab: 'CC', role: ['SUPER'] },
    //     ],
    //     role: ['SUPER'],
    //     visible: true
    // },


];

@Component({
    moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['sidebar.component.scss']
})

export class SidebarComponent {
    constructor(
        private router: Router,
        private http: HttpService,
        private ngZone: NgZone,
    ) {

    }

    public menuItems: any[];
    elementos: any[] = []
    subscriptions = new Subscription();

    mensajesNoLeidos: number = 0



    isNotMobileMenu() {
        if (window.outerWidth > 991) {
            return false;
        }
        return true;
    }

    ngOnInit() {
        const usuario = JSON.parse(this.http.getLocalstorage('usuario'))
        const tipoUsuario = usuario.TipoUsuario

        // Filtra los elementos de nivel principal de acuerdo al tipo de usuario
        this.menuItems = ROUTES.filter(e => e.role.includes(tipoUsuario))

        // Filtra los elementos del nivel secundario
        this.menuItems.forEach(element => {
            if (element.children) {
                element.children = element.children.filter(e => e.role.includes(tipoUsuario))
            }
        });

        console.log('this.menuItems', this.menuItems);

        this.ngZone.run(() => { })

        this.mensajesNoLeidos = +localStorage.getItem('mensajesChat')
        console.log('this.mensajesNoLeidos', this.mensajesNoLeidos);


        console.log('url', this.router.url);


        this.subscriptions.add(this.http.evento$.subscribe(data => {

            console.log('data en sidebar', data);

            if (this.router.url == '/chat')
                return;

            if (data.Evento == 4 || data.Evento == 5)
                this.mensajesNoLeidos++
        }))

    }

    logout() {
        console.log('logout');

        // Borra los datos del cache
        //this.http.deleteCaching();
        localStorage.clear()
        this.router.navigateByUrl('login')
    }

    goToSoporte() {
        this.router.navigateByUrl('soporte')
    }

    ngAfterViewInit() {

    }

    ngOnDestroy(): void {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
    }
}
